<svelte:options runes={true} />

<script lang="ts">
	import * as ResizablePrimitive from 'paneforge';
	import SheetPaneGroup from './SheetPaneGroup.svelte';
	import SplitPaneGroup from './SplitPaneGroup.svelte';

	let paneGroupApi: ResizablePrimitive.PaneGroupAPI | undefined = $state();

	interface Props {
		isVisible?: boolean;
		title?: string;
		asSheet?: boolean;
		class?: string;
		sheetOpen?: boolean;
		children?: import('svelte').Snippet;
	}

	let {
		isVisible = true,
		title = 'Meeting Notes',
		asSheet = false,
		class: className = '',
		sheetOpen = $bindable(false),
		children
	}: Props = $props();
</script>

<!-- Mobile: Use MobilePaneGroup -->
{#if asSheet}
	<SheetPaneGroup bind:sheetOpen {isVisible} {title}>
		{@render children?.()}
	</SheetPaneGroup>
{:else}
	<!-- Desktop: Use Resizable PaneGroup -->
	<SplitPaneGroup {isVisible} bind:paneGroupApi direction="horizontal" class={className}>
		{@render children?.()}
	</SplitPaneGroup>
{/if}
